import { ProtectedRoute } from '@/components/ProtectedRoute'
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom'
import { lazy } from 'react'

import { AppHeader } from '@/layout/appHeader'
import { AppWithBreadcrumbs } from '@/layout/AppWithBreadcrumbs'
import { AuthRoutes } from '@/routes/AuthRoutes'
import { AppLayout } from '@/layout/appLayout'

// Lazy load Home component for public access
const Home = lazy(() =>
  import('@/pages/Home').then(module => ({ default: module.Home })),
)

export const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Auth Routes */}
        <Route path="/auth/*" element={<AuthRoutes />} />

        {/* Public Home Route */}
        <Route
          path="/"
          element={
            <AppLayout>
              <AppHeader />
              <Home />
            </AppLayout>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <>
                <AppHeader />
                <AppWithBreadcrumbs />
              </>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  )
}
